import React, { useEffect, useState } from 'react'
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core'
import moment from 'moment'
import Fetching from './Fetching'

// Aba "Histórico", compartilhada entre Bloqueio Manual e Blacklist. Recebe o
// repository e o id do registro; o fetch é sob demanda, disparado pelo pai
// só quando a aba é aberta pela primeira vez.
const HistoricoBloqueioDesbloqueio = ({ repository, id }) => {
  const [historico, setHistorico] = useState(null)
  const [loading, setLoading] = useState(false)
  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    if (!id) {
      return
    }

    const fetchHistorico = async () => {
      setLoading(true)
      setHasError(false)
      const response = await repository.getHistorico(id)
      if (response.ok) {
        setHistorico(response.data)
      } else {
        setHasError(true)
      }
      setLoading(false)
    }

    fetchHistorico()
  }, [id, repository])

  if (!id) {
    return (
      <Typography>
        Salve o registro para visualizar o histórico de bloqueios e
        desbloqueios.
      </Typography>
    )
  }

  if (loading) {
    return <Fetching />
  }

  if (hasError) {
    return (
      <Typography variant="body2">
        Houve um erro ao buscar o histórico!
      </Typography>
    )
  }

  const ultimosRegistros = historico?.ultimosRegistros || []

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <Typography>
          Total de Bloqueios: {historico?.totalBloqueios ?? 0}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Typography>
          Total de Desbloqueios: {historico?.totalDesbloqueios ?? 0}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        {ultimosRegistros.length ? (
          <TableContainer>
            <Table
              size="small"
              aria-label="Histórico de bloqueios e desbloqueios"
            >
              <TableHead>
                <TableRow>
                  <TableCell>Data/Hora</TableCell>
                  <TableCell>Tipo</TableCell>
                  <TableCell>Usuário</TableCell>
                  <TableCell>Motivo</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ultimosRegistros.map((registro, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      {moment(registro.data).format('DD/MM/YYYY HH:mm')}
                    </TableCell>
                    <TableCell>{registro.tipo}</TableCell>
                    <TableCell>{registro.usuario || '-'}</TableCell>
                    <TableCell>{registro.motivo || '-'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography>Nenhum registro de histórico encontrado</Typography>
        )}
      </Grid>
    </Grid>
  )
}

export default React.memo(HistoricoBloqueioDesbloqueio)
